import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class WorkDoneWithIcon extends Field {
  static subqueriesForModel() {
    return { workDone: ['text'] };
  }

  get title() {
    return 'Work done with icon';
  }

  exampleContents(): FieldContentsData {
    return {
      prefix: 'W',
      text: '1d',
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.workDone?.text) {
      return {
        prefix: 'W',
        text: record.workDone.text,
      };
    }

    return {};
  }
}
